<template>
  <div class="rx-tool">
    <!-- 步骤1：输入正则 -->
    <div class="editor-pane">
      <div class="pane-header">
        <span class="pane-dot input-dot"/><span class="pane-label">{{ $t('tool.RegexTester.title') }}</span>
        <span class="pane-hint">{{ $t('tool.RegexTester.patternHint') }}</span>
      </div>
      <div class="rx-pattern-row">
        <el-input v-model="pattern" size="small" :placeholder="$t('tool.RegexTester.phRegex')" class="rx-mono rx-flex" @input="test"/>
        <span :class="['rx-flag','rx-flag-full',{on:fullMatch}]" @click="fullMatch=!fullMatch;test()" :title="$t('tool.RegexTester.fullMatch')">{{ $t('tool.RegexTester.flagFull') }}</span>
        <span v-for="f in ['g','i','m','s','u']" :key="f"
          :class="['rx-flag',{on:flags.includes(f)}]" @click="toggleFlag(f)">{{ f }}</span>
      </div>
      <div class="rx-pattern-err" v-if="patternErr">{{ patternErr }}</div>
    </div>

    <!-- 步骤2：测试文本 -->
    <div class="editor-pane">
      <div class="pane-header">
        <span class="pane-dot output-dot"/><span class="pane-label">{{ $t('tool.RegexTester.title') }}</span>
        <span class="pane-hint" v-if="text&&fullMatch" :class="fullMatchOk?'rx-match-ok':'rx-match-fail'">{{ fullMatchOk ? $t('tool.RegexTester.matchOk') : $t('tool.RegexTester.matchFail') }}</span>
        <span class="pane-hint" v-else-if="text">{{ $t('tool.RegexTester.totalMatches', { n: matchCount }) }}</span>
      </div>
      <div class="rx-text-wrap">
        <div class="rx-text-backdrop">
          <div class="rx-text-highlights" v-html="highlightHtml"></div>
        </div>
        <textarea class="rx-textarea rx-mono-text" v-model="text" @input="test" @scroll="syncScroll"
          :placeholder="$t('tool.RegexTester.phTestArea')" spellcheck="false"></textarea>
      </div>
    </div>

    <!-- 步骤3：匹配结果 -->
    <div class="editor-pane" v-if="matches.length">
      <div class="pane-header">
        <span class="pane-dot" style="background:#e6a23c;box-shadow:0 0 6px rgba(230,162,60,.4)"/>
        <span class="pane-label">{{ $t('tool.RegexTester.title') }}</span>
        <span class="pane-hint">{{ $t('tool.RegexTester.matchCount', { n: matches.length }) }}</span>
      </div>
      <div class="rx-matches">
        <div class="rx-match-item" v-for="(m,i) in matches" :key="i">
          <span class="rx-match-idx">{{ i+1 }}</span>
          <code class="rx-match-val">{{ m }}</code>
        </div>
      </div>
    </div>

    <!-- 空状态 -->
    <div class="rx-empty" v-if="!pattern && !text">
      <div class="rx-empty-icon">.*</div>
      <div class="rx-empty-title">{{ $t('tool.RegexTester.emptyTitle') }}</div>
      <div class="rx-empty-desc">{{ $t('tool.RegexTester.emptyDesc') }}</div>
      <div class="rx-empty-steps">
        <div class="rx-step"><span class="rx-step-num">1</span>{{ $t('tool.RegexTester.emptyStep1') }}</div>
        <div class="rx-step"><span class="rx-step-num">2</span>{{ $t('tool.RegexTester.emptyStep2') }}</div>
        <div class="rx-step"><span class="rx-step-num">3</span>{{ $t('tool.RegexTester.emptyStep3') }}</div>
      </div>
    </div>

    <!-- 常用参考 -->
    <div class="rx-ref">
      <span class="rx-ref-lbl">{{ $t('tool.RegexTester.quickRef') }}</span>
      <span v-for="r in i18nRefs" :key="r.key" class="rx-chip" @click="loadRef(r)">{{ r.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name:'RegexTesterTool',props:{config:{type:Object,default:()=>({})}},
  data:function(){
    return {
      pattern:'',flags:['g'],text:'',matches:[],patternErr:'',fullMatch:false,fullMatchOk:false,
      refs:[
        {key:'refEmail',pattern:'[\\w.-]+@[\\w.-]+\\.\\w+',text:'联系我 admin@example.com 或 support@test.cn',flags:['g']},
        {key:'refPhone',pattern:'1[3-9]\\d{9}',text:'13812345678 不是手机号 15900001111',flags:['g']},
        {key:'refUrl',pattern:'https?://[\\w./?=&#%+-]+',text:'访问 https://example.com/path?a=1 了解更多',flags:['g']},
        {key:'refDate',pattern:'\\d{4}-\\d{2}-\\d{2}',text:'2026-01-15 到 2026-06-30 期间有效',flags:['g']},
        {key:'refIp',pattern:'\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}',text:'服务器 IP: 192.168.1.1 和 10.0.0.1',flags:['g']},
        {key:'refChinese',pattern:'[\\u4e00-\\u9fa5]+',text:'Hello 世界！这是中文测试 text 文本',flags:['g']},
        {key:'refHexColor',pattern:'#[0-9a-fA-F]{6}',text:'主色 #4e7cff，辅色 #67c23a 和 #e6a23c',flags:['g']},
        {key:'refIdCard',pattern:'\\d{17}[\\dXx]',text:'身份证号 110101199001011234 请核实',flags:['g']},
      ],
      i18nRefs:[]
    }
  },
  created:function(){this.buildRefs();this.$watch(function(){return this.$i18n.locale},this.buildRefs.bind(this))},
  methods:{
    buildRefs:function(){
      var t=this, out=[]
      for (var i=0; i<this.refs.length; i++) {
        var r=this.refs[i]
        out.push({ key:r.key, name:t.$t('tool.RegexTester.'+r.key), pattern:r.pattern, text:r.text, flags:r.flags })
      }
      this.i18nRefs=out
    },
    esc:function(s){return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')},
    toggleFlag:function(f){
      var i=this.flags.indexOf(f)
      if(i>=0)this.flags.splice(i,1);else this.flags.push(f)
      this.test()
    },
    test:function(){
      this.matches=[];this.patternErr='';this.fullMatchOk=false
      if(!this.pattern||!this.text)return
      try{
        var flagsStr=this.flags.join('')
        if(this.fullMatch){
          var re=new RegExp('^(?:'+this.pattern+')$',flagsStr)
          this.fullMatchOk=re.test(this.text)
          if(this.fullMatchOk)this.matches=[this.text]
        }else{
          var re2=new RegExp(this.pattern,flagsStr)
          var m;while((m=re2.exec(this.text))!==null){this.matches.push(m[0]);if(flagsStr.indexOf('g')<0)break}
        }
      }catch(e){this.patternErr=e.message}
    },
    syncScroll:function(e){var bd=this.$el.querySelector('.rx-text-backdrop');if(bd)bd.scrollTop=e.target.scrollTop},
    loadRef:function(r){this.pattern=r.pattern;this.flags=r.flags.slice();this.text=r.text||'';this.test()},
    doAction:function(a){if(a==='clear'){this.pattern='';this.text='';this.matches=[];this.patternErr=''}}
  },
  computed:{
    highlightHtml:function(){
      if(!this.pattern||!this.text)return this.esc(this.text)
      try{
        var re=new RegExp(this.pattern,this.flags.join('').replace('g','')+'g')
        return this.esc(this.text).replace(re,function(m){return'<mark>'+m+'</mark>'})
      }catch(e){return this.esc(this.text)}
    },
    matchCount:function(){return this.matches.length}
  }
}
</script>

<style scoped>
.rx-tool{display:flex;flex-direction:column;gap:14px;max-width:100%}
.editor-pane{background:#fafbfc;border-radius:12px;border:1px solid #ebeef5;padding:16px 20px}
.pane-header{display:flex;align-items:center;gap:8px;margin-bottom:12px}
.pane-dot{width:8px;height:8px;border-radius:50%;flex-shrink:0}
.input-dot{background:#4e7cff;box-shadow:0 0 6px rgba(78,124,255,.4)}
.output-dot{background:#43e97b;box-shadow:0 0 6px rgba(67,233,123,.4)}
.pane-label{font-size:13px;font-weight:700;color:#1a1f36}
.pane-hint{font-size:11px;color:#b0b8c4;margin-left:auto}

/* 正则输入 */
.rx-pattern-row{display:flex;align-items:center;gap:4px}
.rx-mono >>> input{font-family:'JetBrains Mono','Consolas',monospace!important;font-size:14px!important}
.rx-flex{flex:1}
.rx-flag{display:inline-flex;align-items:center;justify-content:center;width:24px;height:24px;border-radius:5px;font-size:11px;font-weight:700;font-family:monospace;cursor:pointer;color:#909399;background:#f0f2f5;transition:.12s;border:1px solid transparent}
.rx-flag:hover{color:#4e7cff;border-color:#4e7cff}
.rx-flag.on{background:#e8f0fe;color:#4e7cff;border-color:#4e7cff}
.rx-flag-full{width:auto;padding:0 8px;font-size:12px}
.rx-match-ok{color:#43a047!important}
.rx-match-fail{color:#e74c3c!important}
.rx-pattern-err{font-size:12px;color:#e74c3c;margin-top:8px;padding:6px 10px;background:#fff5f5;border-radius:6px}

/* 文本输入（双层高亮） */
.rx-text-wrap{position:relative;min-height:120px}
.rx-text-backdrop{position:absolute;top:0;left:0;right:0;bottom:0;overflow:hidden;pointer-events:none;z-index:1}
.rx-text-highlights{padding:12px 15px;font-size:13px;font-family:'JetBrains Mono','Consolas',monospace;line-height:1.7;color:transparent;white-space:pre-wrap;word-break:break-all}
.rx-text-highlights >>> mark{background:rgba(78,124,255,.2);color:transparent;border-radius:2px;padding:1px 0}
.rx-textarea{position:relative;z-index:2;width:100%;box-sizing:border-box;border:1.5px solid #e1e5e9;border-radius:8px;padding:12px 15px;font-size:13px;font-family:'JetBrains Mono','Consolas',monospace;line-height:1.7;color:#303133;outline:none;resize:vertical;background:transparent;min-height:120px;transition:.15s}
.rx-textarea:focus{border-color:#4e7cff;box-shadow:0 0 0 3px rgba(78,124,255,.06);background:rgba(255,255,255,.6)}
.rx-textarea::placeholder{color:#c0c8d4}

/* 匹配结果 */
.rx-matches{display:flex;flex-direction:column;gap:6px;max-height:260px;overflow:auto}
.rx-match-item{display:flex;align-items:flex-start;gap:10px;padding:8px 12px;background:#fff;border:1px solid #f0f2f5;border-radius:7px}
.rx-match-idx{display:flex;align-items:center;justify-content:center;min-width:22px;height:22px;border-radius:50%;background:#fdf6ec;color:#e6a23c;font-size:11px;font-weight:700;flex-shrink:0}
.rx-match-val{font-size:13px;font-family:monospace;color:#303133;word-break:break-all;line-height:1.6}

/* 空状态 */
.rx-empty{text-align:center;padding:32px 20px;color:#b0b8c4}
.rx-empty-icon{font-size:36px;font-family:monospace;font-weight:700;color:#d0d4dc;margin-bottom:12px}
.rx-empty-title{font-size:16px;font-weight:700;color:#909399;margin-bottom:6px}
.rx-empty-desc{font-size:13px;margin-bottom:20px}
.rx-empty-steps{display:flex;justify-content:center;gap:24px;flex-wrap:wrap}
.rx-step{display:flex;align-items:center;gap:8px;font-size:12px;color:#b0b8c4}
.rx-step-num{display:flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%;background:#f0f2f5;color:#909399;font-size:11px;font-weight:700}

/* 参考 */
.rx-ref{display:flex;align-items:center;gap:6px;flex-wrap:wrap}
.rx-ref-lbl{font-size:11px;color:#b0b8c4;white-space:nowrap}
.rx-chip{font-size:11px;padding:4px 10px;border-radius:4px;cursor:pointer;background:#f5f6f8;color:#606266;border:1px solid #e4e7ed;font-family:monospace;transition:.12s}
.rx-chip:hover{border-color:#4e7cff;color:#4e7cff;background:#f0f4ff}

@media(max-width:640px){.rx-empty-steps{flex-direction:column;align-items:center;gap:12px}}
</style>
